import React, { useContext } from "react";
import { useSiteConfig } from "../context/SiteConfigContext";
import { Link } from "react-router-dom";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaYoutube,
  FaLinkedin,
  FaCode,
} from "react-icons/fa";
import { CategoryContext } from "../context/CategoryContext";
import { Mail, MapPin, Phone } from "lucide-react";

function Footer() {
  const { config } = useSiteConfig();
  const { categories } = useContext(CategoryContext);

  return (
    <>
      <footer id="footer" className="heritage-footer">
        <div className="container">
          <div className="row">
            {/* Column 1: Brand Info */}
            <div className="col-lg-3">
              <div   className="custom-footer-logo-text-sec">
                     <Link to="/" className="footer-brand">
                <img src={config?.logo} alt="Pakhis" />
              </Link>
              <p className="footer-desc mb-3  mt-lg-3">
               Handwoven Sarees 
              </p>
              </div>
              
            </div>

            {/* Column 2: Quick Links */}
            <div className="col-lg-2 col-6">
              <h4 className="footer-heading">Quick Links</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/" className="text-decoration-none">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/shop" className="text-decoration-none">
                    Collections
                  </Link>
                </li>
                <li>
                  <Link to="/blog" className="text-decoration-none">
                    Blogs
                  </Link>
                </li>
                <li>
                  <Link to="/contact-us" className="text-decoration-none">
                    Contact Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Useful Links */}
            <div className="col-lg-2 col-6">
              <h4 className="footer-heading">Useful Links</h4>
              <ul className="footer-links">
                <li>
                  <Link to="/privacy-policy" className="text-decoration-none">
                    Privacy Policy
                  </Link>
                </li>
                {/* <li>
                  <Link to="/shipping-delivery-policy" className="text-decoration-none">
                  Shipping & Delivery Policy
                  </Link>
                </li> */}
                <li>
                  <Link
                    to="/terms-and-conditions"
                    className="text-decoration-none"
                  >
                    Terms and Conditions
                  </Link>
                </li>
                <li>
                  <Link
                    to="/return-and-refund-policy"
                    className="text-decoration-none"
                  >
                    Return & Refund Policy
                  </Link>
                </li>
                 <li>
                  <Link to="/about-us" className="text-decoration-none">
                    About Us
                  </Link>
                </li>
              </ul>
            </div>

            {/* Column 3: Useful Links */}
            <div className="col-lg-2 col-6">
              <h4 className="footer-heading">Categories</h4>
              <ul className="footer-links">
                {categories.map((cat) => (
                  <li>
                    <Link
                      key={cat._id}
                      to={`/categories/${cat.slugPath}`}
                      className="text-decoration-none"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Column 4: Newsletter */}
            <div className="col-lg-3 col-6">
              <h4 className="footer-heading">Follow Us</h4>
              <div className="social-row">
                {config?.socialMedia?.facebook && (
                  <a
                    href={config?.socialMedia?.facebook}
                    target="_blank"
                    className="social-icon"
                  >
                    <FaFacebook size={16} />
                  </a>
                )}
                {config?.socialMedia?.instagram && (
                  <a
                    href={config?.socialMedia?.instagram}
                    target="_blank"
                    className="social-icon"
                  >
                    <FaInstagram size={16} />
                  </a>
                )}
                {config?.socialMedia?.twitter && (
                  <a
                    href={config?.socialMedia?.twitter}
                    target="_blank"
                    className="social-icon"
                  >
                    <FaTwitter size={16} />
                  </a>
                )}
                {config?.socialMedia?.youtube && (
                  <a
                    href={config?.socialMedia?.youtube}
                    target="_blank"
                    className="social-icon"
                  >
                    <FaYoutube size={16} />
                  </a>
                )}
                {config?.socialMedia?.linkedin && (
                  <a
                    href={config?.socialMedia?.linkedin}
                    target="_blank"
                    className="social-icon"
                  >
                    <FaLinkedin size={16} />
                  </a>
                )}
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="copyright-bar">
            <Row className="align-items-center">
              <Col md={6} className="text-start">
                <p className="mb-0 footer-text">
                  All Rights Reserved © {new Date().getFullYear()}  Pakhi's
                </p>
              </Col>
              <Col md={6} className="text-end">
                <a
                  href="https://axesell.com"
                  className="floating-designer-btn"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <div className="floating-content">
                    <img
                      src={`${process.env.PUBLIC_URL}/images/axesell_logo.png`}
                      className="floating-icon"
                      alt="Axesell"
                    />
                  </div>
                </a>
              </Col>
            </Row>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Footer;
